import {
  Box,
  Button,
  Grid,
  Group,
  LoadingOverlay,
  MultiSelect,
  Select,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { sky_blue } from "../../../const/variables";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { DecentralizeReductionEntityModel } from "../../../model/DecentralizeRedution";
import { MessageResponse } from "../../../model/MessageResponse";
interface DecentralizeReductionEntity {
  id: string;
  typeAtuh: string | null;
  empid: number | null;
  listOrgId: string | null;
  createBy?: string;
  createDate?: Date;
  lastupdateBy?: string;
  lastupdateDate?: Date;
}
type Props = {
  fetchData: () => void;
  itemEdit?: DecentralizeReductionEntityModel; // Thêm itemEdit để nhận dữ liệu chỉnh sửa
};
const CreateDecentralizeRedution = ({ fetchData, itemEdit }: Props) => {
  const [dataBranchCode, setDataBranchCode] = useState<SelectListItemBase[]>(
    []
  ); // Danh sách chi nhánh
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    []
  ); //danh sách nhân viên theo chi nhánh
  const [dataDepartment, setDataDepartment] = useState<SelectListItemBase[]>(
    []
  ); // Danh sách phòng ban
  const entity: DecentralizeReductionEntity = {
    id: "",
    typeAtuh: null,
    empid: null,
    listOrgId: null,
    createBy: "2",
    createDate: new Date(),
    lastupdateBy: "2",
    lastupdateDate: new Date(),
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      typeAtuh: (value) =>
        value ? null : "Loại phân quyền xin giảm không được để trống",
      empid: (value) => (value ? null : "Nhân viên không được để trống"),
      listOrgId: (value) =>
        value ? null : "Danh sách phòng ban không được để trống",
    },
  });

  const handleCreateDecentralizeReduction = async (
    dataSubmit: DecentralizeReductionEntity
  ) => {
    open();
    try {
      console.log("dataSubmit", dataSubmit);
      let datahandle = {
        id: dataSubmit.id,
        // id: null,
        typeAtuh:
          dataSubmit.typeAtuh !== null ? Number(dataSubmit.typeAtuh) : null,
        empid: dataSubmit.empid !== null ? Number(dataSubmit.empid) : null,
        listOrgId:
          dataSubmit.listOrgId === ""
            ? null
            : dataSubmit.listOrgId === "0"
            ? dataDepartment
                .filter(
                  (item: any) =>
                    item?.name !== null && item?.departmentId !== null
                )
                .map((i: any) => i?.departmentId?.toString())
                .join(",")
            : dataSubmit.listOrgId,
        createBy: dataSubmit.createBy,
      };
      console.log("datahandle", datahandle);
      let api = "/api/v1/AuthApprove/add-or-update";
      const response = await repositoryPos.post<
        MessageResponse<DecentralizeReductionEntity>
      >(`${api}`, datahandle);
      if (response && response.success) {
        await fetchData();
        modals.closeAll();
        setTimeout(() => {
          NotificationExtension.Success("Thêm mới thành công");
        }, 1000);
      } else {
        NotificationExtension.Fails(
          response?.message || "Có lỗi xảy ra. Vui lòng thử lại!"
        );
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      close();
    }
  };

  //  lấy danh sách chi nhánh
  const DataBranchCode = async () => {
    try {
      // const response = await repositoryPos.get<
      //   MessageResponse<SelectListItemBase[]>
      // >(`api/v1/TblDmInventory/get-select-branch?auth=true`);
      const response = await repositoryDelivery.get<
        MessageResponse<SelectListItemBase[]>
      >(`/api/v1/TblDmMasterOrg/get-select`);
      // console.log("response", response);
      if (response && response.success) {
        const data = response.data;
        setDataBranchCode(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  //  lấy danh sách phòng ban
  const DataDepartmentCode = async () => {
    try {
      // const response = await repositoryPos.get<
      //   MessageResponse<SelectListItemBase[]>
      // >(`/api/v1/TblDepartment/get-select?branchId=0&isShipping=false`);
      const response = await repositoryPos.get<
        MessageResponse<SelectListItemBase[]>
      >(`/api/v1/TblDepartment/get-all`);

      console.log("response", response);
      if (response && response.success) {
        const data = response.data;
        setDataDepartment(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  //   lấy danh sách nhân viên theo chi nhánh
  const getDataEmployee = async () => {
    // const rawListOrgId = form.getValues().listOrgId;
    // // Tách chuỗi thành mảng (nếu là string), hoặc giữ nguyên nếu đã là mảng
    // const listOrgArr =
    //   typeof rawListOrgId === "string"
    //     ? rawListOrgId.split(",").filter(Boolean)
    //     : Array.isArray(rawListOrgId)
    //     ? rawListOrgId
    //     : [];

    // // Tạo query string đúng dạng ListBranchId=31&ListBranchId=14...
    // const query = listOrgArr
    //   .map((id: string) => `ListBranchId=${id}`)
    //   .join("&");

    // const res = await repositoryPos.get<MessageResponse<any>>(
    //   `/api/v1/TblDmEmployee/get-list?${query}&Take=1000`
    // );

    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/get-select`
    );
    // console.log("res", res);
    if (res && res?.success) {
      setDataEmployeeSelect(
        res.data
          .filter(
            (item: any) =>
              item.att1 !== null && item.value !== null && item.text !== null
          )
          .map((i: any) => ({
            value: i.value,
            label: ` ${i.att1} - ${i.text}`,
          }))
      );
    }
  };
  useEffect(() => {
    const run = async () => {
      await DataDepartmentCode();
      await getDataEmployee();
    };
    run();
  }, []);

  useEffect(() => {
    if (itemEdit) {
      const fetchAndSet = async () => {
        if (itemEdit && dataDepartment && dataDepartment.length > 0) {
          // Xử lý listOrgId: nếu số lượng id bằng số lượng phòng ban thì set "0"
          let listOrgIdValue = itemEdit.listOrgId || null;
          if (listOrgIdValue) {
            const arr = listOrgIdValue.split(",").filter(Boolean);
            console.log("arr", arr, arr.length);
            const departmentIds = dataDepartment
              .filter(
                (item: any) =>
                  item?.name !== null && item?.departmentId !== null
              )
              .map((item: any) => item.departmentId?.toString());
            console.log("departmentIds", departmentIds.length);
            // Nếu tất cả phòng ban đều có trong arr thì set "0"
            if (arr && arr.length === departmentIds.length) {
              listOrgIdValue = "0";
              form.setFieldValue("listOrgId", "0");
            }
          }

          form.setValues({
            id: itemEdit.id,
            typeAtuh: itemEdit.typeAtuh?.toString() || null,
            empid: itemEdit.empid || null,
            listOrgId: listOrgIdValue,
            createBy: itemEdit.createBy || "2",
          });
        }
      };
      fetchAndSet();
    }
  }, [itemEdit, dataDepartment]);
  console.log("dataDepartment", dataDepartment);
  console.log("form.getValues()", form.getValues());
  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: DecentralizeReductionEntity) => {
          handleCreateDecentralizeReduction(e);
        })}
        style={{ position: "relative", maxWidth: "500px" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={12}>
            <Select
              label={"Loại phân quyền"}
              placeholder={"Nhập loại phân quyền"}
              withAsterisk
              key={`${form.getValues().typeAtuh}`}
              data={[
                { value: "1", label: "Cấp mức 1" },
                { value: "2", label: "Cấp mức 2" },
              ]}
              {...form.getInputProps("typeAtuh")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <MultiSelect
              placeholder="Chọn phòng ban"
              clearable
              searchable
              data={[
                { value: "-1", label: "Tất cả" },
                ...(Array.isArray(dataDepartment)
                  ? dataDepartment
                      .filter(
                        (item: any) =>
                          item?.name !== null && item?.departmentId !== null
                      )
                      .map((i: any) => ({
                        value: i?.departmentId?.toString(),
                        label: `[${i?.attribute1}] - ${i?.deparmentCode} - ${i?.name}`,
                      }))
                  : []),
              ]}
              withAsterisk
              label="Danh sách phòng ban"
              // key={`${form.getValues().listOrgId}`}
              value={
                form.getValues().listOrgId === "0"
                  ? ["-1"] // Khi giá trị là "0", hiển thị như đã chọn "Tất cả"
                  : form.getValues().listOrgId &&
                    form.getValues().listOrgId !== ""
                  ? (form.getValues().listOrgId ?? "").split(",")
                  : []
              }
              onChange={(value) => {
                if (value.includes("-1")) {
                  form.setFieldValue("listOrgId", "0");
                } else {
                  form.setFieldValue("listOrgId", value.join(","));
                }
              }}
              onBlur={() => form.validateField("listOrgId")}
              error={form.errors.listOrgId}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Select
              placeholder="Nhập mã hoặc tên nhân viên"
              data={dataEmployeeSelect}
              value={form.getValues().empid?.toString() || ""}
              searchable
              clearable
              label="Nhân viên"
              withAsterisk
              onClick={() => {
                if (dataEmployeeSelect.length === 0) {
                  getDataEmployee();
                }
              }}
              onChange={(value) => {
                form.setFieldValue("empid", value ? Number(value) : null);
              }}
              key={`${form.getValues().empid}`}
              onBlur={() => form.validateField("empid")}
              error={form.errors.empid}
              //   {...form.getInputProps("empid")}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default CreateDecentralizeRedution;
